const stringReplace = (inString, toReplace = '', withString = '', noString = '') => {
  return (typeof inString === 'string') ? inString.replace(toReplace, withString) : noString;
};

export default stringReplace;
